export default "__VITE_ASSET__ed6bac4c__"